// eslint-disable-next-line import/no-extraneous-dependencies
import { createContext } from 'react';
export const overrideContext = /*#__PURE__*/createContext(new Map());